import { FastifyPluginAsync } from 'fastify';
import { NotificationsService } from './notifications.service.js';
import {
  GetNotificationsQuerySchema,
  MarkReadBodySchema,
  MarkAllReadQuerySchema,
} from './notifications.schemas.js';
import { logger } from '../../utils/logger.js';
import { authMiddleware } from '../../middleware/auth.middleware.js';

const notificationsService = new NotificationsService();

export const notificationsRoutes: FastifyPluginAsync = async (fastify) => {
  /**
   * GET /api/notifications
   * Get user notifications
   */
  fastify.get(
    '/',
    {
      preHandler: [authMiddleware]
    },
    async (request, reply) => {
      try {
        const userId = request.user!.uid;
        const query = GetNotificationsQuerySchema.parse(request.query);

        const result = await notificationsService.getNotifications(userId, query);

        return reply.send(result);
      } catch (error) {
        logger.error('Failed to get notifications', { error });
        return reply.code(500).send({
          error: 'Failed to get notifications',
        });
      }
    }
  );

  /**
   * POST /api/notifications/mark-read
   * Mark notifications as read
   */
  fastify.post(
    '/mark-read',
    {
      preHandler: [authMiddleware]
    },
    async (request, reply) => {
      try {
        const { notificationIds } = MarkReadBodySchema.parse(request.body);

        await notificationsService.markAsRead(notificationIds);

        return reply.send({ success: true });
      } catch (error) {
        logger.error('Failed to mark notifications as read', { error });
        return reply.code(500).send({
          error: 'Failed to mark notifications as read',
        });
      }
    }
  );

  /**
   * POST /api/notifications/mark-all-read
   * Mark all notifications as read
   */
  fastify.post(
    '/mark-all-read',
    {
      preHandler: [authMiddleware]
    },
    async (request, reply) => {
      try {
        const userId = request.user!.uid;
        const query = MarkAllReadQuerySchema.parse(request.query);

        const count = await notificationsService.markAllAsRead(userId, query.before);

        return reply.send({ success: true, count });
      } catch (error) {
        logger.error('Failed to mark all notifications as read', { error });
        return reply.code(500).send({
          error: 'Failed to mark all notifications as read',
        });
      }
    }
  );
};
